import { SkipButton } from "./SkipButton";

const formatTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

export const TimeDisplay = ({
  duration,
  currentTime,
  handleSkipBack,
  handleSkipForward,
}: {
  duration?: number;
  currentTime: number;
  handleSkipBack: () => void;
  handleSkipForward: () => void;
}) => (
  <div className="flex items-center justify-between" onDoubleClick={(e) => e.stopPropagation()}>
    <SkipButton direction="back" handleClick={handleSkipBack} />
    <div className="p2-medium flex w-[127px] justify-center">
      {duration ? (
        <>
          <div className="ml-[-20px] mr-[2px] min-w-[55px] text-right">
            {formatTime(currentTime)}
          </div>
          <div>/ {formatTime(duration)}</div>
        </>
      ) : (
        <div>00:00</div>
      )}
    </div>
    <SkipButton direction="forward" handleClick={handleSkipForward} />
  </div>
);
